import { useState, useCallback, createContext, useContext } from 'react';

const ModalsContext = createContext({});

export const ModalsProvider = ({ children }) => {
  const [loginOpen, setLoginOpen] = useState(false);
  const [registerOpen, setRegisterOpen] = useState(false);
  const [contactOpen, setContactOpen] = useState(false);
  const [plansOpen, setPlansOpen] = useState(false);
  const [licensePlate, setLicensePlate] = useState('');
  const [planType, setPlanType] = useState('');
  const [forgotPasswordOpen, setForgotPasswordOpen] = useState(false);

  const handleOpenLogin = useCallback((plate, plan) => {
    if (plate && typeof plate === 'string' && plate !== 'true') {
      setLicensePlate(plate);
    } else {
      setLicensePlate('');
    }
    
    if (plan) {
      setPlanType(plan);
    }
    setRegisterOpen(false);
    setLoginOpen(true);
  }, []);

  const handleCloseLogin = useCallback(() => {
    setLoginOpen(false);
  }, []);

  const handleOpenRegister = useCallback(() => {
    setRegisterOpen(true);
  }, []);

  const handleCloseRegister = useCallback(() => {
    setRegisterOpen(false);
  }, []);

  const handleOpenPlans = (plate) => {
    setLicensePlate(plate);
    setPlansOpen(true);
  };

  const handleClosePlans = useCallback(() => {
    setPlansOpen(false);
  }, []);

  const handleOpenForgotPassword = () => setForgotPasswordOpen(true);
  const handleCloseForgotPassword = () => setForgotPasswordOpen(false);

  const value = {
    loginOpen,
    registerOpen,
    contactOpen,
    plansOpen,
    licensePlate,
    planType,
    setContactOpen,
    handleOpenLogin,
    handleCloseLogin,
    handleOpenRegister,
    handleCloseRegister,
    handleOpenPlans,
    handleClosePlans,
    setLicensePlate,
    setPlanType,
    forgotPasswordOpen,
    handleOpenForgotPassword,
    handleCloseForgotPassword,
  };

  return (
    <ModalsContext.Provider value={value}>
      {children}
    </ModalsContext.Provider>
  );
};

export const useModals = () => {
  const context = useContext(ModalsContext);
  if (context === undefined) {
    throw new Error('useModals must be used within a ModalsProvider');
  }
  return context;
};